import { useSimplePlaylists } from 'academy-common-lib/features/hubspotPlaylists/hooks/useSimplePlaylists';
import SavePlaylistButton from '../../myPlaylists/components/SavePlaylistButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getMyPlaylistsUrl } from '../../myPlaylists/myPlaylistsRouting';
import ArchivePlaylistButton from '../../myPlaylists/components/ArchivePlaylistButton';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SavePlaylistNotification = ({
  playlistId
}) => {
  var _simplePlaylists$play;
  // needs to retrieve the hydrated model for the playlist name
  // will be removed after migration
  const {
    simplePlaylists
  } = useSimplePlaylists({
    playlistIds: [playlistId]
  });
  const playlistName = (simplePlaylists === null || simplePlaylists === void 0 || (_simplePlaylists$play = simplePlaylists[playlistId]) === null || _simplePlaylists$play === void 0 ? void 0 : _simplePlaylists$play.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.savedPlaylist",
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getMyPlaylistsUrl({
        tab: 'saved'
      }),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'academyCommon.savedItems.tooltips.viewSavedPlaylists'
      })
    }), /*#__PURE__*/_jsx(SavePlaylistButton, {
      marginInlineStart: "300",
      playlistId: playlistId,
      textAlign: "center",
      use: "link-on-dark",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.undo"
      })
    })]
  });
};
export const UnsavePlaylistNotification = ({
  playlistId
}) => {
  var _simplePlaylists$play2;
  // needs to retrieve the hydrated model for the playlist name
  // will be removed after migration
  const {
    simplePlaylists
  } = useSimplePlaylists({
    playlistIds: [playlistId]
  });
  const playlistName = (simplePlaylists === null || simplePlaylists === void 0 || (_simplePlaylists$play2 = simplePlaylists[playlistId]) === null || _simplePlaylists$play2 === void 0 ? void 0 : _simplePlaylists$play2.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.unsavedPlaylist",
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getMyPlaylistsUrl({
        tab: 'saved'
      }),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.viewSavedPlaylists"
      })
    })]
  });
};
export const ArchivePlaylistNotification = ({
  playlistId
}) => {
  var _simplePlaylists$play3;
  // needs to retrieve the hydrated model for the playlist name
  // will be removed after migration
  const {
    simplePlaylists
  } = useSimplePlaylists({
    playlistIds: [playlistId]
  });
  const playlistName = (simplePlaylists === null || simplePlaylists === void 0 || (_simplePlaylists$play3 = simplePlaylists[playlistId]) === null || _simplePlaylists$play3 === void 0 ? void 0 : _simplePlaylists$play3.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.archivedPlaylist",
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getMyPlaylistsUrl({
        tab: 'archived'
      }),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.viewArchivedPlaylists"
      })
    }), /*#__PURE__*/_jsx(ArchivePlaylistButton, {
      marginInlineStart: "300",
      playlistId: playlistId,
      textAlign: "center",
      use: "link-on-dark",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.undo"
      })
    })]
  });
};
export const UnarchivePlaylistNotification = ({
  playlistId
}) => {
  var _simplePlaylists$play4;
  // needs to retrieve the hydrated model for the playlist name
  // will be removed after migration
  const {
    simplePlaylists
  } = useSimplePlaylists({
    playlistIds: [playlistId]
  });
  const playlistName = (simplePlaylists === null || simplePlaylists === void 0 || (_simplePlaylists$play4 = simplePlaylists[playlistId]) === null || _simplePlaylists$play4 === void 0 ? void 0 : _simplePlaylists$play4.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.unarchivedPlaylist",
      options: {
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getMyPlaylistsUrl(),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.viewMyPlaylists"
      })
    })]
  });
};